import { useMemo } from 'react';

import { useSelector } from 'react-redux';

import { getUserHasFullAccess } from '~/selectors/plans.selectors';
import { FeatureFlags, useFeatureFlag } from '~/utils/featureflags';

import { PrintInitiation, type PrintAssetType } from '../types/print.type';
import { usePrinterConfig } from './usePrinterConfig';

export type UseScanToPrintReturn = {
  isConfiguredForScanToPrint: boolean;
};

/**
 * Whether to show scan-to-print UI (the barcode icon).
 */
export const useScanToPrint = (assetType: PrintAssetType): UseScanToPrintReturn => {
  const isFlagEnabled = useFeatureFlag(FeatureFlags.QUICKPACK_SCAN_TO_PRINT)?.enabled ?? false;
  const hasFullAccess = useSelector(getUserHasFullAccess);
  const { isWorkstationFetched, preferences } = usePrinterConfig();

  const isConfiguredForScanToPrint =
    isFlagEnabled &&
    hasFullAccess &&
    isWorkstationFetched &&
    preferences[assetType]?.initiation === PrintInitiation.ScanToPrint;

  return useMemo(() => ({ isConfiguredForScanToPrint }), [isConfiguredForScanToPrint]);
};
